import React from "react";
import { LOGO_URL } from "../lib/api";
import { buildWhatsAppUrl } from "../lib/whatsapp";
import { Phone, Mail, MessageCircle } from "lucide-react";

export const Footer = ({ whatsappNumber = "919315542583" }) => {
  return (
    <footer id="contact" className="bg-[#0B192C] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="logo" className="h-12 w-12 rounded-full object-cover" />
            <div>
              <div className="font-display text-2xl font-bold">MY BEEMA<span className="text-emerald-400">.in</span></div>
              <div className="text-xs uppercase tracking-[0.25em] text-white/60">One Stop. All Protection.</div>
            </div>
          </div>
          <p className="mt-5 text-white/70 max-w-sm leading-relaxed">
            <span className="font-display italic text-emerald-300">Ek Hi Jagah, Sabhi Suraksha!</span> — Compare,
            quote and buy across 10+ insurance categories with trusted advisors.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-emerald-400" strokeWidth={1.5} />
              <a data-testid="footer-phone" href={`tel:+${whatsappNumber}`} className="hover:text-white">+91 93155 42583</a>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle className="w-4 h-4 text-emerald-400" strokeWidth={1.5} />
              <a
                data-testid="footer-whatsapp"
                href={buildWhatsAppUrl(whatsappNumber, "Hi MY BEEMA, I'd like a quote.")}
                target="_blank"
                rel="noreferrer"
                className="hover:text-white"
              >
                WhatsApp Us
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-emerald-400" strokeWidth={1.5} />
              <a href="mailto:support@mybeema.in" className="hover:text-white">support@mybeema.in</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4">Trust Pillars</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Trusted Advice</li>
            <li>Smart Solutions</li>
            <li>Customer First</li>
            <li>Value That Matters</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50">
          <div>© {new Date().getFullYear()} MY BEEMA. All rights reserved.</div>
          <div className="font-display italic text-emerald-300/80 mt-2 md:mt-0">Secure Today, Secure Tomorrow.</div>
        </div>
      </div>
    </footer>
  );
};
